import React from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import PageSection from "../../components/PageSection";
import { useQuery } from "@apollo/client";
import { POLESETS } from "../../graphql/gqlPoleset";
import { useParams } from "react-router-dom";
import AddPoleToSetButton from "./AddPoleToSetButton";
import { DeletePolesetButton } from "./DeletePolesetButton";
import ColorIndicator from "../../components/ColorIndicator";
import { DeletePoleFromSetButton } from "./DeletePoleFromSetButton";
import { EditPoleInSetButton } from "./EditPoleInSetButton";
import { T } from "../../components/T";
import { defaultPoleset } from "../../hooks/useInventory";

const PolesetsPage = () => {
  const theme = useTheme();
  const { userId } = useParams();

  const polesetsQuery = useQuery(POLESETS, {
    variables: { userId },
  });

  const polesets = polesetsQuery?.data?.getPolesetsByUserId;

  if (polesetsQuery.loading || polesetsQuery.error || !polesets) return null;

  const sortedPolesets = [...polesets].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return (
    <Box
      sx={{
        overflowY: "auto",
        bgcolor: theme.palette.background.default,
        py: 4,
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          color: theme.palette.text.primary,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          <T str="Polesets" />
        </Typography>
        {sortedPolesets.map((set) => {
          const sortedPoles = [...set.poles].sort(
            (a, b) => a.length - b.length
          );
          return (
            <PageSection title={set.name} key={set.id}>
              {" "}
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableBody>
                    {sortedPoles.map((poleType) => (
                      <TableRow key={poleType.id}>
                        <TableCell>
                          <ColorIndicator color={poleType.color} />
                        </TableCell>
                        <TableCell
                          align={"right"}
                          sx={{ fontWeight: "bold" }}
                        >{`${poleType.length} m`}</TableCell>
                        <TableCell align={"right"}>
                          <EditPoleInSetButton
                            polesetId={set.id}
                            poleId={poleType.id}
                            length={poleType.length}
                            color={poleType.color}
                          />
                          <DeletePoleFromSetButton
                            polesetId={set.id}
                            poleId={poleType.id}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <AddPoleToSetButton setId={set.id} />
                <DeletePolesetButton setId={set.id} />
              </Box>
            </PageSection>
          );
        })}

        <PageSection
          title={<T str="Default poleset" />}
          key={defaultPoleset.id}
        >
          {" "}
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableBody>
                {defaultPoleset.poles.map((poleType) => (
                  <TableRow key={poleType.id}>
                    <TableCell>
                      <ColorIndicator color={poleType.color} />
                    </TableCell>
                    <TableCell
                      align={"left"}
                      sx={{ fontWeight: "bold" }}
                    >{`${poleType.length} m`}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </PageSection>
      </Container>
    </Box>
  );
};

export default PolesetsPage;
